// App.js
import React, { useState, useEffect} from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';
import './App.css';
import Map from './Map';
import Filter from './Filter';
import EduInInfo from './EduInInfo';
import Header from './Header';
import Footer from './Footer';
import Intro from './Intro';
import Stati from './Stati';
import SearchBar from './SearchBar';


function App() {
  const [latestDistrict, setLatestDistrict] = useState('');
  const [latestPalika, setLatestPalika] = useState('');
  const [loading, setLoading] = useState(true);
  const [isEnglish, setIsEnglish] = useState(false);
  const navigate = useNavigate();
  



  useEffect(() => {
    const delay = setTimeout(() => {
      setLoading(false);
    }, 2000);

    return () => clearTimeout(delay);
  }, []);

  const handleLanguageSwitch = () => {
    setIsEnglish((prevIsEnglish) => !prevIsEnglish);
  };

  const handleDistrictChange = (district) => {
    setLatestDistrict(district);
    setLatestPalika('');
  };

  const handlePalikaChange = (palika) => {
    setLatestPalika(palika);
  };

  const handleMapClick = (clickedDistrict) => {
    setLatestDistrict(clickedDistrict);
    setLatestPalika('');
  };

  const handleMapClick1 = (clickedPalika) => {
    setLatestPalika(clickedPalika);
  };
 
  const otherDetails = (
    <div>
      {/* Add other details */}
      {isEnglish ? <p>English content</p> : <p>Content in another language</p>}
    </div>
  );

  return (
    <div className="App">
      {!loading && <Header onLanguageSwitch={handleLanguageSwitch} isEnglish={isEnglish} />}
      <Routes>
        <Route path="/edu" element={<EduInInfo isEnglish={isEnglish} />} />
        <Route
          path="/"
          element={
            <>
              {loading ? (
                <Intro />
              ) : (
                <>
                 <Filter
        latestDistrict={latestDistrict}
        latestPalika={latestPalika}
        onDistrictChange={handleDistrictChange}
        onPalikaChange={handlePalikaChange}
        isEnglish={isEnglish}
      />
    
                  <div className="combined-component">
                    <Stati
                      latestDistrict={latestDistrict}
                      latestPalika={latestPalika}
                      isEnglish={isEnglish}
                    />
                    <Map
                      latestDistrict={latestDistrict}
                      latestPalika={latestPalika}
                      onMapClick={handleMapClick}
                      onMapClick1={handleMapClick1}
                      isEnglish={isEnglish}
                    />
                  </div>

               
                </>
              )}
            </>
          }
        />
      </Routes>
      {!loading && <Footer isEnglish={isEnglish} />}
    </div>
  );
}

export default App;
